import axios from "axios";

export default {
    connectMicrosoftId: async (microsoft_token) => {
        await axios.post(`/current_person/connect/microsoft/`, {
            microsoft_token
        })
    },
    removeMicrosoftId: async () => {
        await axios.delete(`/current_person/connect/microsoft/`)
    },
    connectGoogleId: async (google_token) => {
        await axios.post(`/current_person/connect/google/`, {
            google_token
        })
    },
    removeGoogleId: async () => {
        await axios.delete(`/current_person/connect/google/`)
    },
    connectXeroId: () => {
        window.location = '/api/xero/connect'
    },
    removeXeroId: async () => {
        await axios.delete(`/current_person/connect/xero/`)
    },
    getAllowedLoginOptions: async () => {
        const { data } = await axios.get(`/profile/allowed_login_options/`)
        return data
    },
}
